import React from "react";

const footer = () => {
  return (
    <div className="container-fluid d-flex justify-content-center align-items-center footerBox">
      <p className="fontSize12">
        © Maximus Infoware (India) Private Limited 2022
      </p>
    </div>
  );
};

export default footer;
